// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TRu7","tabsBox":"styles_tabsBox__1MkQF","createButton":"styles_createButton__17jZ0"};